/**
 * AndVGauge - 仪表盘组件
 * 基于 Ant Design Charts Gauge
 */
import React from 'react';
import { Gauge } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVGaugeProps } from '../base/types';

const DEFAULT_GAUGE_DATA = {
  target: 92,
  total: 100,
  name: '设备完好率',
  thresholds: [25, 50, 75, 100],
};

const DEFAULT_GAUGE_SCALE = {
  color: {
    range: ['#FF7875', '#FFC069', '#95DE64', '#52C41A'],
  },
};

const DEFAULT_GAUGE_STYLE = {
  arcShape: 'round',
  pointerStroke: '#52C41A',
  pointerLineWidth: 3,
  pinFill: '#ffffff',
  pinStroke: '#52C41A',
  pinLineWidth: 2,
  textContent: '完好率: 92',
  textFill: '#434343',
  textFontSize: 22,
  textFontWeight: 700,
  textY: '58%',
};

// 使用 HOC 包装基础 Gauge 组件
const GaugeWithBase = withBaseChart<AndVGaugeProps>(Gauge, {
  chartType: 'AndVGauge',
  defaultHeight: 300,
  defaultData: DEFAULT_GAUGE_DATA,
});

/**
 * AndVGauge 仪表盘组件
 * 用于展示单个指标的完成度或进度，适用于 KPI 展示
 */
export const AndVGauge: React.FC<AndVGaugeProps> = (props) => {
  const { style, scale, ...baseProps } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    style: style ?? DEFAULT_GAUGE_STYLE,
    scale: parseJsonProp(scale) ?? DEFAULT_GAUGE_SCALE,
  };

  return <GaugeWithBase {...chartProps} />;
};

export type { AndVGaugeProps };
export default AndVGauge;
